<template>
	<div class="join_us" v-show="tabarr.length">
		<div class="jus_pc pt_90" v-if="!isPhone">
			<pageBanner :imgurl="banner"></pageBanner>
			<location lone="交控纳贤" v-if="tabarr.length" :ltwo="tabarr[tabact].title"></location>
			<div class="con_wrap">
				<div class="con_box flex1">
					<div class="con_left">
						<tabson :titobj="tabtit" :tablist="tabarr" :actIndex="tabact" @tab-change="tabChange"></tabson>
						<br>
						<contact></contact>
					</div>
					<div class="con_right">
						<div class="tfm_tit" v-if="tabarr.length">{{tabarr[tabact].title}}</div>
						<router-view></router-view>
					</div>
				</div>
			</div>
		</div>
		<div class="jus_ph" v-if="isPhone">
			<Header2 :searchShow="true" pageTitle="交控纳贤"></Header2>
			<pageBanner2 :imgurl="banner"></pageBanner2>
			<div class="ph_tab_box flex3">
				<div class="ph_tab_item" v-for="(item,index) in tabarr" :key="index" @click="tabChange2(index,item)">
					<span :class="tabact==index?'ph_act1':''">{{ item.title }}</span>
				</div>
			</div>
			<div class="rout_box">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			banner: '',
			tabtit: {
				title1: '交控纳贤',
				title2: 'Join Building',
			},
			tabact: 0,
			tabarr: [],
			isPhone: this.$isMobile,
		}
	},
	computed: {
		...mapState(["headList"]),
	},
	mounted() {
		this.getTabArr(this.headList)
	},
	watch: {
		$route(to, from) {
			if (to.fullPath == '/joinUs/jobBoard') {
				this.tabact = 0;
			}
			if (to.fullPath == '/joinUs/contactUs') {
				this.tabact = 1;
			}
		},
		headList(newVal, oldVal) {
			if (newVal.length) {
				this.getTabArr(newVal)
			}
		}
	},
	created() {
		if (this.$route.fullPath == '/joinUs/jobBoard') {
			this.tabact = 0;
		}
		if (this.$route.fullPath == '/joinUs/contactUs') {
			this.tabact = 1;
		}
    },
	methods: {
		getTabArr(arr) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].name == '/joinUs/jobBoard') {
					this.banner = this.$staticImg + arr[i].image;
					this.tabarr = arr[i].son;
				}
			}
		},
		tabChange(index) {
			this.tabact = index;
		},
		tabChange2(index, item) {
			this.tabact = index;
			this.$router.push(item.name);
		}
	}
}
</script>
<style lang="scss">
.join_us {
	.jus_ph {
		padding-top: 1.23rem;
		padding-bottom: 80px;
	}
}
</style>